import { combineReducers } from 'redux';

import accountReducer from './account.reducer';
import portalReducer from './portal.reducer';

const rootReducer = combineReducers({
    account: accountReducer,
    portal: portalReducer,
});
export default rootReducer;